import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import App from './App';
import * as bootstrap from 'bootstrap'
/* import '../src/Assets/Stylesheets/bootstrap-5.0.2/css/bootstrap.min.css' */

//import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import './Assets/Stylesheets/Modules.css'
import './Assets/Stylesheets/media-queries.css'
ReactDOM.render(
  //<React.StrictMode>
  <BrowserRouter>
    <App />
    </BrowserRouter>,
  //</React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

//reportWebVitals();
